import { FlexContainer, Subtitle, TYPOGRAPHY, Title } from '@emarketer/componentlibrary';
import styled from 'styled-components';

export const PillRadioPickerWrapper = styled.div``;

export const PillRadioPickerOptions = styled(FlexContainer)``;

export const PillRadioPickerOption = styled(FlexContainer)<{ hideRadioButton?: boolean }>`
  width: 100%;
  ${(p) =>
    p.hideRadioButton
      ? `
  input {
    visibility: hidden;
  }`
      : ''}
`;

export const PillRadioPickerSearch = styled.div`
  margin-bottom: 20px;
`;

export const PillRadioPickerParent = styled(FlexContainer)`
  margin-bottom: 20px;
`;

export const PillRadioPickerContainer = styled.div`
  padding: 24px;
  min-width: 320px;
`;

export const PillRadioPickerLabel = styled(Subtitle)``;

export const PillRadioPickerParentLabel = styled(Title)`
  font-size: 14px !important;
  ${TYPOGRAPHY.BLACK};
`;
